// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-back-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  margin-left: var(--space-2, 8px);
  padding: 0;
  background: none;
  border: 1px solid transparent;
  border-radius: 4px;
  color: var(--text-muted);
  opacity: 0.6;
  cursor: pointer;
  transition: opacity 150ms ease, color 150ms ease, border-color 150ms ease, background 150ms ease;
  flex-shrink: 0;
}

.sidebar-back-btn:hover {
  opacity: 1;
  color: var(--text-primary);
  border-color: rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.04);
}

.sidebar-back-btn:focus-visible {
  outline: 2px solid var(--accent-primary, #ef4444);
  outline-offset: 2px;
}

.sidebar-back-btn svg {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/SidebarBackButton/SidebarBackButton.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,UAAU;EACV,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,gGAAgG;EAChG,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB","sourcesContent":[".sidebar-back-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  margin-left: var(--space-2, 8px);\n  padding: 0;\n  background: none;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  color: var(--text-muted);\n  opacity: 0.6;\n  cursor: pointer;\n  transition: opacity 150ms ease, color 150ms ease, border-color 150ms ease, background 150ms ease;\n  flex-shrink: 0;\n}\n\n.sidebar-back-btn:hover {\n  opacity: 1;\n  color: var(--text-primary);\n  border-color: rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.sidebar-back-btn:focus-visible {\n  outline: 2px solid var(--accent-primary, #ef4444);\n  outline-offset: 2px;\n}\n\n.sidebar-back-btn svg {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
